<template>
  <span class="protege-chip d-inline-flex align-center justify-center">
    <AIAssistantIcon :width="12" :height="12" class="flex-shrink-0 mr-1" />
    <span class="protege-chip-label text--small font-weight-bold">{{ label }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AIAssistantIcon from '@/common/ai-assistant/AIAssistantIcon.vue'

export default defineComponent({
  name: 'ProtegeChip',
  components: {
    AIAssistantIcon,
  },
  props: {
    label: {
      type: String as PropType<string>,
      default: 'Protégé™',
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.protege-chip {
  min-height: 20px;
  background-color: #efe8ff;
  color: #7c5fd4;
  @include border-radius('border-radius-pill');
  line-height: 1;
  flex-shrink: 0;
  padding: 2px 4px;
}

.protege-chip-label {
  font-size: 12px;
  line-height: 1;
}
</style>
